import React from 'react';
import JewelleryPriceCalculator from '../components/JewelleryPriceCalculator';
import LiveRatesSection from '../components/LiveRatesSection';
import MarketingOfferBanner from '../components/MarketingOfferBanner';
import TrustSection from '../components/TrustSection';
import { Calculator, Sparkles } from 'lucide-react';

export default function CalculatorPage() {
  return (
    <div style={{ backgroundColor: '#f1f3f6', minHeight: '100vh', paddingBottom: '3rem' }}>
      
      {/* Page Header */}
      <div style={{
        background: 'linear-gradient(135deg, #781313 0%, #b91c1c 100%)',
        color: '#ffffff',
        padding: '2.5rem 1rem 2rem',
        textAlign: 'center'
      }}>
        <div className="container" style={{ maxWidth: '1240px', margin: '0 auto' }}>
          <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.4rem',
            background: 'rgba(255, 255, 255, 0.15)',
            border: '1px solid rgba(255, 255, 255, 0.25)',
            borderRadius: '20px',
            padding: '0.25rem 0.8rem',
            fontSize: '0.74rem',
            fontWeight: 800,
            textTransform: 'uppercase',
            letterSpacing: '0.06em',
            marginBottom: '0.6rem'
          }}>
            <Calculator size={13} color="#ffe500" />
            <span>Precise Showroom Billing</span>
          </div>
          <h1 style={{
            margin: '0 0 0.5rem',
            fontSize: 'clamp(1.6rem, 3vw, 2.4rem)',
            fontWeight: 800,
            fontFamily: "'Playfair Display', serif, Georgia"
          }}>
            Gold & Silver Jewellery Price Calculator
          </h1>
          <p style={{
            margin: 0,
            fontSize: '0.92rem',
            color: '#fef08a',
            maxWidth: '640px',
            margin: '0 auto'
          }}>
            Input your ornament weight, making charge, wastage %, and stones to see the exact invoice price with 3% GST breakdown.
          </p>
        </div>
      </div>

      <MarketingOfferBanner />

      {/* Main Interactive Calculator */}
      <JewelleryPriceCalculator />

      {/* Current Bullion Spot Cards for Quick Reference */}
      <LiveRatesSection />

      {/* Hallmark Guarantee */}
      <TrustSection />

    </div>
  );
}
